import { render, staticRenderFns } from "./actual-vessels.vue?vue&type=template&id=17184658&scoped=true"
import script from "./actual-vessels.vue?vue&type=script&lang=js"
export * from "./actual-vessels.vue?vue&type=script&lang=js"
import style0 from "./actual-vessels.vue?vue&type=style&index=0&id=17184658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17184658",
  null
  
)

export default component.exports